import { useState, useEffect } from 'react'

import DownloadStudentUsageModal from './DownloadStudentUsageModal'
import useModal from '../../../../lib/hooks/useModal'
import { useAuth } from '../../../provider/OIDCProvider'

type DownloadStudentUsageModalWrapperProps = {
  isOpen: boolean
}

const DownloadStudentUsageModalWrapper = ({ isOpen }: DownloadStudentUsageModalWrapperProps) => {
  const [token, setToken] = useState<string | undefined>(undefined)
  const { hideModal } = useModal()
  const { getTokenSilently } = useAuth()

  useEffect(() => {
    // getting the token for form POST could be better
    async function getToken() {
      const accessToken = await getTokenSilently()
      setToken(accessToken)
    }
    getToken()
  }, [setToken, getTokenSilently])

  const onCancel = () => {
    hideModal()
  }

  return <DownloadStudentUsageModal isOpen={isOpen} onCancel={onCancel} token={token} />
}

export default DownloadStudentUsageModalWrapper
